<div class="inline-filters">
	@for (filter of filters; track filter.key) {
		<app-pill-filter
			[label]="filter.label"
			[options]="filter.options || []"
			[mode]="filter.type === 'datepicker' ? 'daterange' : 'select'"
			[value]="values[filter.key] ?? null"
			(valueChange)="onValueChange(filter.key, $event)"
		></app-pill-filter>
	}
</div>
